module.exports = __webpack_public_path__ + "static/media/leaf.58919ddb.svg";